<template>
  <div class="vue-tempalte">
    <div class="App">
      <LoginModal v-if="showLoginModal" @closeLoginModal="closeLoginModal" />

      <Tabnav v-if="$route.name === 'home' || $route.name === 'credit' || $route.name === 'templates'" />
      <vue3-confirm-dialog></vue3-confirm-dialog>
      <!-- <div class="custom-sidebar" v-if="isTab" style="position: fixed;">
        <ul class=" sidebar-list">
          <div v-for="(item, index) in menu" :key="item.href || index">
            <li class="sidebar-item " v-if="item.href">
              <div class="d-flex justify-content-between align-items-center w-100">

                <router-link :to="item.href" class="sidebar-link ">
                  <i :class="item.icon" class="me-2"></i>
                  <p class="m-0"> {{ item.title }}</p>
                </router-link>




                <div class="dropdown" v-if="item.canDelete && item.href">
                  <span class="material-symbols-outlined more-icon" @click="toggleDropdown(index)">
                    more_horiz
                  </span>

                  <div v-if="dropdownOpen === index" class="action-menu">
                    <div class="center-center">
                      <span class="material-symbols-outlined" style="font-size: 16px;">
                        edit
                      </span>
                      <a href="#" class="dropdown-item" @click.prevent="renameItem(item)">
                        Rename</a>
                    </div>

                    <div class="center-center">
                      <span class="material-symbols-outlined text-danger" style="font-size: 16px;">
                        delete
                      </span>
                      <a href="#" class="dropdown-item text-danger" @click.prevent="removeItem(item)">
                        Delete</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <span style="color: #5f5f5f;" v-else>
              <i :class="item.icon" class="me-2"></i>
              <span class="m-0" style="font-size:14px">{{ item.title }}</span>
            </span>
          </div>
        </ul>
      </div> -->
      <div>
        <div :class="[!isNotLogin ? '' : 'inner-block']">
          <div class="row">
            <!-- <div class="col-2">


            </div> -->
            <div :class="[isTab && 'col-12']">
              <!-- <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
              </keep-alive> -->
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Tabnav from './components/Tabnav.vue'
import LoginModal from './components/LoginModal.vue';
import LoginScreen from './views/LoginScreen.vue';
export default {
  components: { Tabnav, LoginModal, LoginScreen },
  async mounted() {
    const isRegister = localStorage.getItem('isRegister')
    console.log('isRegister', isRegister)
    if (isRegister === 'notfound') {
      this.$router.push('/logout');
    }
    // return localStorage.removeItem('history')
    const history = this.$storex.getters.getHistory

    console.log(history)
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    showLoginModal() {
      return this.$store.getters.showLoginModal
    },
    // a computed getter
    token: function () {
      // `this` points to the vm instance
      return localStorage.getItem('jwtToken')
    },
    isNotLogin: function () {
      // Compare the current route's name with the provided name
      return this.$route.name != 'login';
    },
    isTab: function () {
      // Compare the current route's name with the provided name
      return this.$route.name != 'editor' && this.$route.name != 'editorPlan' && this.$route.name != 'template' && this.$route.name != 'login' && this.$route.name != 'template-editor';
    },
    history() {
      return this.$storex.getters.getHistory || [];
    },
    menu() {
      const staticMenu = [
        { href: '/home', title: 'Home', icon: 'fa fa-user' },
      ];
      const historyList = Array.isArray(this.history) ? this.history : [];

      const historyMenu = historyList.map(h => ({
        href: `/editor/${h.id}`,
        title: `${(h.title || '').slice(0, 32)}...`,
        icon: 'fa fa-history',
        canDelete: true, // << เพิ่ม property นี้
        id: h.id // สำหรับลบ
      }));

      return [
        ...staticMenu,
        ...(historyMenu.length > 0 ? [{ title: 'Document' }, ...historyMenu] : []),
      ];
    }

  },
  data() {
    return {
      dropdownOpen: null, // index ของ dropdown ที่เปิด
    }
  },
  methods: {
    toggleDropdown(index) {
      this.dropdownOpen = this.dropdownOpen === index ? null : index;
    },
    renameItem(item) {
      const newTitle = prompt('Rename to:', item.title);
      if (newTitle) {
        this.$storex.commit('renameHistoryById', { id: item.id, title: newTitle });
      }
      this.dropdownOpen = null;
    },
    closeLoginModal() {
      this.$store.commit('setShowLoginModal', false)
    },
    removeItem(item) {


      console.log(item)
      this.$confirm(
        {
          message: 'Are you sure?',
          button: {
            no: 'No',
            yes: 'Yes'
          },

          callback: confirm => {
            if (confirm) {
              this.removeHistory(item.id)
            }
            else {
              this.dropdownOpen = false
            }
          }
        }
      )
    },
    async removeHistory(id) {
      try {
        // เรียก API เพื่อลบข้อมูลใน backend (Firestore)
        await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/history/delete`, { id });

        // ก๊อปข้อมูลปัจจุบันจาก store มาแก้ไข
        const currentHistory = [...this.$store.getters.getHistory];

        // ลบ item ที่มี id ตรงกัน
        const updatedHistory = currentHistory.filter(item => item.id !== id);

        // อัปเดต Vuex store
        this.$store.dispatch("setHistory", updatedHistory);
        this.dropdownOpen = false
        console.log('✅ History deleted:', id);
      } catch (error) {
        console.error("❌ Failed to delete history:", error);
      }
    },
    handleClickOutside(event) {
      const dropdowns = document.querySelectorAll('.dropdown');
      let clickedInside = false;

      dropdowns.forEach(dropdown => {
        if (dropdown.contains(event.target)) {
          clickedInside = true;
        }
      });

      if (!clickedInside) {
        this.dropdownOpen = null;
      }
    },

  }

};
</script>
<style></style>